export default "__VITE_ASSET__BZbek7V$__"